import {_} from 'vue-underscore'
import {mapGetters} from 'vuex'
import templateEndpoints from "@/api/templates"
import {tryExceptAwait} from "@/utils"
import {ExtendCurtainTemplate} from "vue-flow-generator/src/mixins/TemplateTranslator"
import {EventBus} from "@/plugins/bus";
import {TRACK_RAIL} from "@/constants";

export default {
  mixins: [
    ExtendCurtainTemplate
  ],
  computed: {
    ...mapGetters({
      curtainType: 'order/getCurtainType',
      mainFabric: 'order/getFabric',
      railRodParameters: 'order/getRailRodParameters',
    })
  },
  methods: {
    /*
    * Fetch curtain template with information about the selected
    * curtain's options, given the curtain type
    */
    async fetchCurtainTemplateData(curtainType) {
      // make sure curtain type and fabric are present
      if (!curtainType || _.isEmpty(this.mainFabric)) {
        return null
      }
      // prepare the request
      this.$wait.start('isLoadingCurtainTemplate')
      // build url params
      const urlParams = {curtainType}
      const height = this.curtainParameters.height
      const data = Object.assign(
        // always add a fabric uuid, this is mandatory
        {fabric_uuid: this.mainFabric.fabric_uuid},
        // only add the following (fold curtain) parameters if they are set
        height && {height: height}
      )
      // execute request with url params and json body
      const response = await tryExceptAwait(
        templateEndpoints.getCurtainTemplate,
        [urlParams, data]
      )
      this.$wait.end('isLoadingCurtainTemplate')
      return response.status === 200 ? response.data : {}
    },
    /* Fetch template methods
     * For Intergamma like flows we have composite products with
     * tieback and cut yardage steps in the main flow, so then
     * fetchTiebackTemplate/fetchCutYardageTemplate can be added
     */
    async fetchCurtainTemplate() {
      const rawTemplate = await this.fetchCurtainTemplateData(this.curtainType)
      if (!rawTemplate) return
      const curtainTemplate = this.extendTemplate(rawTemplate)
      await this.$store.dispatch('order/setCurtainTemplate', curtainTemplate)
      EventBus.$emit('load-curtain-article-to-flow')
    },
    translateSizeDefinitionValidation(item) {
      if (this.hasValidationRules(item)) {
        const {max, min} = item
        return `required|double:1|min_value:${min}|max_value:${max}`
      }
      return "required|double:1"
    },
  }
}
